import { Box, Checkbox, FormControlLabel, FormGroup, Grid, Slider, Typography } from "@mui/material"
import styleCss from "../Style/style"
import FilterIcon from "../img/time-icon.png"
import PriceTag from "../img/price-tag.png"
import { useEffect, useState } from "react"
import dayjs from "dayjs"
import { AuthAxios } from "../Utilities/CommonAxios"
import showToast from "../Utilities/showToast"

const BusFilter = ({ fromDetails, toDetails, travelDates }) => {
    const from = JSON.parse(fromDetails);
    const to = JSON.parse(toDetails)
    const travelDate = dayjs(travelDates).format("YYYY-MM-DD")
    const [value, setValue] = useState([10, 100]);
    const [departureTime, setDepartureTime] = useState([]);
    const [operatorType, setOperatorType] = useState([]);
    const [amenitiesType, setAmenitiesType] = useState([]);
    const [busTypes, setBusTypes] = useState([]);

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    const departure = async () => {
        try {
            const apiResponse = await AuthAxios({
                url: '/departure_time',
                method: 'post',
                payload: {
                    "origin_boarding_id": from?.boarding_point_id,
                    "origin_city_id": from?.city_id,
                    "destination_boarding_id": to?.boarding_point_id,
                    "destination_city_id": to?.city_id,
                    "date_of_journey": travelDate
                }
            })
            if (apiResponse.status) {
                setDepartureTime(apiResponse?.data)
            } else {
                // showToast('error', apiResponse?.message)
                setDepartureTime([])
            }

        } catch (error) {
            // showToast('error', error.message);
            setDepartureTime([])

        }
    }

    const amenities = async () => {
        try {
            const apiResponse = await AuthAxios({
                url: '/amenities',
                method: 'post',
                payload: {
                    "origin_boarding_id": from?.boarding_point_id,
                    "origin_city_id": from?.city_id,
                    "destination_boarding_id": to?.boarding_point_id,
                    "destination_city_id": to?.city_id,
                    "date_of_journey": travelDate
                }
            })
            if (apiResponse.status) {
                setAmenitiesType(apiResponse?.data)
            } else {
                showToast('error', apiResponse?.message)
                setAmenitiesType([])
            }

        } catch (error) {
            // showToast('error', error.message);
            setAmenitiesType([])

        }
    }

    const operator = async () => {
        try {
            const apiResponse = await AuthAxios({
                url: '/bus_operators',
                method: 'post',
                payload: {
                    "origin_boarding_id": from?.boarding_point_id,
                    "origin_city_id": from?.city_id,
                    "destination_boarding_id": to?.boarding_point_id,
                    "destination_city_id": to?.city_id,
                    "date_of_journey": travelDate
                }
            })
            if (apiResponse.status) {
                setOperatorType(apiResponse?.data)
            } else {
                showToast('error', apiResponse?.message)
                setOperatorType([])
            }

        } catch (error) {
            // showToast('error', error.message);
            setOperatorType([])

        }
    }

    const busType = async () => {
        try {
            const apiResponse = await AuthAxios({
                url: '/bus_type',
                method: 'post',
                payload: {
                    "origin_boarding_id": from?.boarding_point_id,
                    "origin_city_id": from?.city_id,
                    "destination_boarding_id": to?.boarding_point_id,
                    "destination_city_id": to?.city_id,
                    "date_of_journey": travelDate
                }
            })
            if (apiResponse.status) {
                setBusTypes(apiResponse?.data)
            } else {
                showToast('error', apiResponse?.message)
                setBusTypes([])
            }

        } catch (error) {
            // showToast('error', error.message);
            setBusTypes([])

        }
    }

    useEffect(() => {
        departure();
        operator();
        amenities();
        busType();
    }, [fromDetails, toDetails, travelDates]);

    return (
        <>
            {/* filter-box */}
            {/* <Box sx={{
                padding: "10px",
                borderRadius: "12px",
                border: "1px solid #e5e5e5",
                backgroundColor: "#fff",
                marginBottom: '15px',
            }}>
                <Grid container spacing={2}>
                    <Grid size={{ md: 12, xs: 12 }}>
                        <Typography
                            sx={{
                                display: "flex",
                                alignItems: "center",
                                gap: "5px",
                                fontFamily: "Segoe UI",
                                fontSize: "17px",
                                fontWeight: 600,
                                color: "#0e182b",
                                marginBottom: '5px',
                            }}
                        >
                            <img
                                src={FilterIcon}
                                alt="filter"
                            />
                            Filters
                        </Typography>
                    </Grid>
                </Grid>
                <FormGroup>
                    <Grid container spacing={2} alignItems="center" sx={{ padding: "0px", borderBottom: "1px solid #f0f0f0" }}>
                        <Grid size={{ md: 9, xs: 9 }}>
                            <FormControlLabel control={<Checkbox />} label="Before 6 AM" sx={styleCss.FilterLabel} />
                        </Grid>
                        <Grid size={{ md: 3, xs: 3 }} sx={{ textAlign: "end" }}>
                            <Typography sx={styleCss.FilterNumber}>23</Typography>
                        </Grid>
                    </Grid>

                
                    <Grid container spacing={2} alignItems="center" sx={{ padding: "0px", borderBottom: "1px solid #f0f0f0" }}>
                        <Grid size={{ md: 9, xs: 9 }}>
                            <FormControlLabel control={<Checkbox />} label="6 AM - 9 AM" sx={styleCss.FilterLabel} />
                        </Grid>
                        <Grid size={{ md: 3, xs: 3 }} sx={{ textAlign: "end" }}>
                            <Typography sx={styleCss.FilterNumber}>18</Typography>
                        </Grid>
                    </Grid>

                
                    <Grid container spacing={2} alignItems="center" sx={{ padding: "0px", borderBottom: "1px solid #f0f0f0" }}>
                        <Grid size={{ md: 9, xs: 9 }}>
                            <FormControlLabel control={<Checkbox />} label="9 AM - 12 PM" sx={styleCss.FilterLabel} />
                        </Grid>
                        <Grid size={{ md: 3, xs: 3 }} sx={{ textAlign: "end" }}>
                            <Typography sx={styleCss.FilterNumber}>32</Typography>
                        </Grid>
                    </Grid>

             
                    <Grid container spacing={2} alignItems="center" sx={{ padding: "0px", borderBottom: "1px solid #f0f0f0" }}>
                        <Grid size={{ md: 9, xs: 9 }}>
                            <FormControlLabel control={<Checkbox />} label="12 PM - 3 PM" sx={styleCss.FilterLabel} />
                        </Grid>
                        <Grid size={{ md: 3, xs: 3 }} sx={{ textAlign: "end" }}>
                            <Typography sx={styleCss.FilterNumber}>15</Typography>
                        </Grid>
                    </Grid>

                
                    <Grid container spacing={2} alignItems="center" sx={{ padding: "0px" }}>
                        <Grid size={{ md: 9, xs: 9 }}>
                            <FormControlLabel control={<Checkbox />} label="After 3 PM" sx={styleCss.FilterLabel} />
                        </Grid>
                        <Grid size={{ md: 3, xs: 3 }} sx={{ textAlign: "end" }}>
                            <Typography sx={styleCss.FilterNumber}>10</Typography>
                        </Grid>
                    </Grid>
                </FormGroup>
            </Box> */}

            <Box sx={{
                padding: "10px",
                borderRadius: "12px",
                border: "1px solid #e5e5e5",
                backgroundColor: "#fff",
                marginBottom: '15px',
            }}>
                <Grid container spacing={2}>
                    <Grid size={{ md: 12, xs: 12 }}>
                        <Typography
                            sx={{
                                display: "flex",
                                alignItems: "center",
                                gap: "5px",
                                fontFamily: "Segoe UI",
                                fontSize: "17px",
                                fontWeight: 600,
                                color: "#0e182b",
                                marginBottom: '5px',
                            }}
                        >
                            <img
                                src={FilterIcon}
                                alt="filter"
                            />
                            Departure Time
                        </Typography>
                    </Grid>
                </Grid>
                <FormGroup>
                    {departureTime && departureTime.map((e, i) => (
                        <Grid container spacing={2} alignItems="center" sx={{ padding: "0px", borderBottom: "1px solid #f0f0f0" }}>
                            <Grid size={{ md: 9, xs: 9 }}>
                                <FormControlLabel control={<Checkbox />} label={`${e.label}`} sx={styleCss.FilterLabel} />
                            </Grid>
                            <Grid size={{ md: 3, xs: 3 }} sx={{ textAlign: "end" }}>
                                <Typography sx={styleCss.FilterNumber}>{e.count}</Typography>
                            </Grid>
                        </Grid>
                    ))}
                </FormGroup>
            </Box>
            <Box sx={{
                padding: "10px",
                borderRadius: "12px",
                border: "1px solid #e5e5e5",
                backgroundColor: "#fff",
                marginBottom: '15px',
            }}>
                <Grid container spacing={2}>
                    <Grid size={{ md: 12, xs: 12 }}>
                        <Typography
                            sx={{
                                display: "flex",
                                alignItems: "center",
                                gap: "5px",
                                fontFamily: "Segoe UI",
                                fontSize: "17px",
                                fontWeight: 600,
                                color: "#0e182b",
                                marginBottom: '5px',
                            }}
                        >
                            Bus Type
                        </Typography>
                    </Grid>
                </Grid>
                <FormGroup>
                    {busTypes && busTypes.map((b, i) => (
                        <Grid container spacing={2} alignItems="center" sx={{ padding: "0px", borderBottom: "1px solid #f0f0f0" }}>
                            <Grid size={{ md: 9, xs: 9 }}>
                                <FormControlLabel control={<Checkbox />} label={b?.label} sx={styleCss.FilterLabel} />
                            </Grid>
                            <Grid size={{ md: 3, xs: 3 }} sx={{ textAlign: "end" }}>
                                <Typography sx={styleCss.FilterNumber}>{b?.count}</Typography>
                            </Grid>
                        </Grid>
                    ))}
                </FormGroup>
            </Box>
            {/* end */}
            {/* Price Range */}
            <Box sx={{
                padding: "10px",
                borderRadius: "12px",
                border: "1px solid #e5e5e5",
                backgroundColor: "#fff",
                marginBottom: '15px',
            }}>
                <Grid container spacing={2}>
                    <Grid size={{ md: 12, xs: 12 }}>
                        <Typography
                            sx={{
                                display: "flex",
                                alignItems: "center",
                                gap: "5px",
                                fontFamily: "Segoe UI",
                                fontSize: "17px",
                                fontWeight: 600,
                                color: "#0e182b",
                                marginBottom: '5px',
                            }}
                        >
                            <img
                                src={PriceTag}
                                alt="filter"
                            />
                            Price Range
                        </Typography>
                    </Grid>
                    <Grid size={{ md: 12, xs: 12 }}>
                        <Box sx={{ width: '100%', padding: '0px 10px' }} mx="auto">
                            {/* Slider */}
                            <Slider
                                value={value}
                                onChange={handleChange}
                                min={0}
                                max={100}
                                valueLabelDisplay="auto"
                                aria-labelledby="range-slider"
                            />

                            {/* Values at edges */}
                            <Box display="flex" justifyContent="space-between">
                                <Typography sx={styleCss.Valuenumberstyle}>{value[0]}</Typography>
                                <Typography sx={styleCss.Valuenumberstyle}>{value[1]}</Typography>
                            </Box>
                        </Box>

                    </Grid>
                </Grid>

            </Box>
            {/* <Box sx={{
                padding: "10px",
                borderRadius: "12px",
                border: "1px solid #e5e5e5",
                backgroundColor: "#fff",
                marginBottom: '15px',
            }}>
                <Grid container spacing={2}>
                    <Grid size={{ md: 12, xs: 12 }}>
                        <Typography
                            sx={{
                                display: "flex",
                                alignItems: "center",
                                gap: "5px",
                                fontFamily: "Segoe UI",
                                fontSize: "17px",
                                fontWeight: 600,
                                color: "#0e182b",
                                marginBottom: '5px',
                            }}
                        >
                            Safety Features
                        </Typography>
                    </Grid>
                </Grid>
                <FormGroup>
                    <Grid container spacing={2} alignItems="center" sx={{ padding: "0px", borderBottom: "1px solid #f0f0f0" }}>
                        <Grid size={{ md: 9, xs: 9 }}>
                            <FormControlLabel control={<Checkbox />} label="Safety + Buses only" sx={styleCss.FilterLabel} />
                        </Grid>
                        <Grid size={{ md: 3, xs: 3 }} sx={{ textAlign: "end" }}>
                            <Typography sx={styleCss.FilterNumber}>23</Typography>
                        </Grid>
                    </Grid>
                </FormGroup>
            </Box> */}
            {/* end */}
            {/* Amenities*/}
            <Box sx={{
                padding: "10px",
                borderRadius: "12px",
                border: "1px solid #e5e5e5",
                backgroundColor: "#fff",
                marginBottom: '15px',
            }}>
                <Grid container spacing={2}>
                    <Grid size={{ md: 12, xs: 12 }}>
                        <Typography
                            sx={{
                                display: "flex",
                                alignItems: "center",
                                gap: "5px",
                                fontFamily: "Segoe UI",
                                fontSize: "17px",
                                fontWeight: 600,
                                color: "#0e182b",
                                marginBottom: '5px',
                            }}
                        >
                            Amenities
                        </Typography>
                    </Grid>
                </Grid>
                <FormGroup>
                    {amenitiesType && amenitiesType.map((a, i) => (
                        <Grid container spacing={2} alignItems="center" sx={{ padding: "0px", borderBottom: "1px solid #f0f0f0" }}>
                            <Grid size={{ md: 12, xs: 12 }}>
                                <FormControlLabel control={<Checkbox />} label={a?.ammenity_name} sx={styleCss.FilterLabel} />
                            </Grid>
                        </Grid>
                    ))}
                </FormGroup>
            </Box>

            <Box sx={{
                padding: "10px",
                borderRadius: "12px",
                border: "1px solid #e5e5e5",
                backgroundColor: "#fff",
                marginBottom: '15px',
            }}>
                <Grid container spacing={2}>
                    <Grid size={{ md: 12, xs: 12 }}>
                        <Typography
                            sx={{
                                display: "flex",
                                alignItems: "center",
                                gap: "5px",
                                fontFamily: "Segoe UI",
                                fontSize: "17px",
                                fontWeight: 600,
                                color: "#0e182b",
                                marginBottom: '5px',
                            }}
                        >
                            <img
                                src={FilterIcon}
                                alt="filter"
                            />
                            Bus Operators
                        </Typography>
                    </Grid>
                </Grid>
                <FormGroup>
                    {operatorType && operatorType.map((op, i) => (
                        <Grid container spacing={2} alignItems="center" sx={{ padding: "0px", borderBottom: "1px solid #f0f0f0" }}>
                            <Grid size={{ md: 9, xs: 9 }}>
                                <FormControlLabel control={<Checkbox />} label={op?.operator_name} sx={styleCss.FilterLabel} />
                            </Grid>
                            <Grid size={{ md: 3, xs: 3 }} sx={{ textAlign: "end" }}>
                                <Typography sx={styleCss.FilterNumber}>{op?.count}</Typography>
                            </Grid>
                        </Grid>

                    ))}
                </FormGroup>
            </Box>
            {/* end */}
        </>
    )
}
export default BusFilter